export default "__VITE_ASSET__BiBeWyzZ__"